export enum DiamondSpinState {
	Idle,
	IntroMessage,
	WaitForSpin,
	Spin,
	CommetRun,
	Win,
	Collect,
	SpinIdle,
	FinalMessage,
}